import React, { useState } from 'react';
import Config from 'config/config';
import {
  useMaintenanceState,
  maintenancePreview,
  UPCOMING,
  IN_PROGRESS,
} from 'helpers/maintenance_helper';
import MaintenanceBanner from './maintenance_banner';
import MaintenancePage from './maintenance_page';

export default function MaintenanceGate({
  children,
  reloadPage = () => window.location.reload(),
}) {
  const [preview] = useState(() => maintenancePreview(window.location.search));
  const { start, end } = Config.maintenanceWindow;
  const state = useMaintenanceState({
    start,
    end,
    preview,
    onWindowEnd: reloadPage,
  });

  if (state === IN_PROGRESS) {
    return <MaintenancePage />;
  }

  return (
    <>
      {state === UPCOMING && <MaintenanceBanner />}
      {children}
    </>
  );
}
